import { analyticsClient } from "./analytics-client.ts";
import type { AnalyticsEventName } from "./catalog.ts";

/** Thin entrypoint so call sites don't reach into the singleton class directly. */
export function track(name: AnalyticsEventName, properties?: Record<string, unknown>): void {
  analyticsClient.track(name, properties);
}

const RETURNING_STORAGE_KEY = "jod.customer.analytics.has-opened";

export type LiffEntryPoint = "table_qr" | "oa_rich_menu" | "shared_link";

/**
 * Best-effort `liff_opened` context (AEV-001). ASSUMPTION: the app has no
 * dedicated LINE OA rich-menu launch parameter today, so `table_qr` is
 * detected from the `?t=` QR token query param (see `routes/join-table.tsx`)
 * and everything else falls back to `shared_link`.
 */
export function resolveLiffEntryPoint(): { entryPoint: LiffEntryPoint; tableRef?: string } {
  if (typeof window === "undefined") return { entryPoint: "shared_link" };
  const params = new URLSearchParams(window.location.search);
  const tableRef = params.get("t") ?? undefined;
  if (tableRef) return { entryPoint: "table_qr", tableRef };
  return { entryPoint: "shared_link" };
}

/** True if this browser has opened the app before (best-effort, `localStorage`-based). */
export function resolveIsReturning(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const seen = window.localStorage.getItem(RETURNING_STORAGE_KEY) === "1";
    window.localStorage.setItem(RETURNING_STORAGE_KEY, "1");
    return seen;
  } catch {
    return false;
  }
}
